import { FilterIcon, SortIcon } from 'components/Icons';

import { IconButton, Row, RowProps } from 'components/Blocks';

interface ButtonsProps {
  hasFilter?: boolean;
  hasSort?: boolean;
  onSortClick?: () => void;
  onFilterClick?: () => void;
  gap?: RowProps['gap'];
}

export function SortFilterButtons({
  hasFilter,
  hasSort,
  onFilterClick,
  onSortClick,
  gap = '2',
}: ButtonsProps) {
  return (
    <Row gap={gap}>
      {onSortClick && (
        <IconButton
          onClick={onSortClick}
          className={hasSort ? 'border border-primary text-primary' : 'text-foreground'}
        >
          <SortIcon />
        </IconButton>
      )}

      {onFilterClick && (
        <IconButton
          onClick={onFilterClick}
          className={hasFilter ? 'border border-primary text-primary' : 'text-foreground'}
        >
          <FilterIcon />
        </IconButton>
      )}
    </Row>
  );
}
